export default __webpack_public_path__ + "static/media/calculator.8c00179c.svg";